import { Layout } from '../components/Layout';
import Meta from '../components/Meta';
import { Heading } from '../components/Heading';
import { Bounded } from '../components/Bounded';
import ProjectCalendar from '../components/ProjectCalendar';

const ProjectCalendarPage = ({ projects, navigation, settings }) => {
  const project_list = projects.results
    // item needs a title, and must have either a start_date or be tentative
    .map((project) => ({
      ...project,
      data: {
        ...project.data,
        timeline_items: project.data.timeline_items?.filter(
          (item) => item.title && (item.start_date || item.tentative)
        )
      }
    }))
    // only include projects with timeline items (not empty ones)
    .filter((project) => project.data.timeline_items?.length);

  return (
    <Layout
      // alternateLanguages={page.alternate_languages} // TODO show all available languages
      navigation={navigation}
      settings={settings}
      page={{}}>
      <Meta
        meta={{
          title: 'Project calendar'
        }}
        settings={settings}
      />
      <Bounded as="section">
        <Heading as="h1" className="mb-4">
          Project calendar
        </Heading>

        {project_list.length > 0 ? (
          <ProjectCalendar projects={project_list} />
        ) : (
          <p>
            There are no active or upcoming projects at the moment, please come
            later.
          </p>
        )}
      </Bounded>
    </Layout>
  );
};

export default ProjectCalendarPage;
